enum LoanStatusEnum {
  PAID = 'PAID',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  DEBT_COLLECTION = 'DEBT_COLLECTION',
}

export default LoanStatusEnum
